import {
    CardStyleInterpolators,
    StackCardInterpolatedStyle,
    StackCardInterpolationProps,
} from "@react-navigation/stack";
import { useIsScreenSizeMin } from "./useIsScreenSizeMin";
import { useCallback } from "react";
import { Platform } from "react-native";

export const useModalCardStyleInterpolator = () => {
    const isLarge = useIsScreenSizeMin("large");

    const cardStyleInterpolator = useCallback<
        (props: StackCardInterpolationProps) => StackCardInterpolatedStyle
    >((props) => {
        const {
            containerStyle = {},
            cardStyle = {},
            overlayStyle = {},
            shadowStyle = {},
        } = CardStyleInterpolators.forFadeFromBottomAndroid(props) as {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            containerStyle: Record<string, any>;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            cardStyle: Record<string, any>;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            overlayStyle: Record<string, any>;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            shadowStyle: Record<string, any>;
        };

        const backgroundColor = props.current.progress.interpolate({
            inputRange: [0, 1],
            outputRange: ["rgba(0, 0, 0, 0.0)", "rgba(0, 0, 0, 0.3)"],
            extrapolate: "clamp",
        });

        const blur = props.current.progress.interpolate({
            inputRange: [0, 1],
            outputRange: ["blur(0px)", "blur(4px)"],
            extrapolate: "clamp",
        });

        return {
            containerStyle: {
                ...containerStyle,
                backgroundColor,
                overflow: "hidden",
                ...(Platform.OS === "web"
                    ? {
                          backdropFilter: blur,
                      }
                    : {}),
            },
            cardStyle: { ...cardStyle },
            overlayStyle: { ...overlayStyle, opacity: 0 },
            shadowStyle: { ...shadowStyle },
        };
    }, []);

    return !isLarge ? CardStyleInterpolators.forVerticalIOS : cardStyleInterpolator;
};
